import React, { useEffect } from "react";
import "./Toolbar.scss";

import { ToolView } from "./ToolView";
import ConsumerTemplateView, { RoomTemplateView } from "../modelViews/ConsumerTemplateView";
import DrawingItemTemplate, { DrawingItemCategory } from "../models/DrawingItemTemplate";
import { ChannelType, getChannelTypePicture } from "../models/ChannelType";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";

import { DeviceClass, DeviceClasses } from "../models/DeviceClasses";
import Browser from "../browser";
import { ToolbarChapter, ToolbarRoomChapter } from "./ToolbarChapter";
import ScrollButton from "./ScrollButton";
import { itx, noItx } from "../translationItx/itx";
import Floor from "../models/Floor";

export default function Toolbar(props: any) {
  useEffect(() => {
    // it was rendert two times(Symbols was shown double)
    if (consumerItems.length == 0) {
      initTemplates();
    }
  }, []);

  useOnChangeWatcher(state.activePanes);
  useOnChangeWatcher(state.activePanes2);
  useOnChangeWatcher(state.selectionManager);

  const activePage = state.getActivePage();

  //
  // On mobile Devices we show the toolbar only when drawings are open
  //

  if (!activePage) {
    return null;
  }

  if (state.settings.diagnosticMode) {
    return null;
  }

  const chapterElements: any = [];
  const roomplanIsOpen: boolean = activePage?.isFloorPlan || activePage?.isRoomPlan;

  if (activePage?.isFloorPlan && activePage.editRooms) {
    const newRoomElements: any = [];
    const roomsElements: any = [];
    const roomTemplate = new DrawingItemTemplate();
    const floor = activePage.parent as Floor;

    roomTemplate.titleShort = itx("components.Room", "Raum");
    roomTemplate.image = "lab la-codepen";

    roomTemplate.category = DrawingItemCategory.Room;
    roomTemplate.className = "Room"; // no itx

    newRoomElements.push(
      <ToolView key={`room`} index={0} data={JSON.stringify(roomTemplate)} disabled={!roomplanIsOpen} imgSrc={""}>
        {<ConsumerTemplateView template={roomTemplate} disabled={!roomplanIsOpen} />}
      </ToolView>,
    );
    floor.rooms.forEach((room) => {
      if (room.roomtoFloorDrawingTransform?.placed || room.isFloorGeneralRoom) {
        return;
      }
      const roomTemplate = new DrawingItemTemplate();
      roomTemplate.category = DrawingItemCategory.Room;
      roomTemplate.className = "Room"; // no itx
      roomTemplate.titleShort = room.name;
      roomTemplate.tag = room.id; // to get room for on drop
      roomsElements.push(
        <ToolView
          key={`room` + room.id}
          index={0}
          data={JSON.stringify(roomTemplate)}
          disabled={!roomplanIsOpen}
          imgSrc={""}
          styleOuter={{ width: "100px" }}
          styleName={noItx("toolRoom")}
          roomId={room.id}
        >
          {<RoomTemplateView template={roomTemplate} disabled={!roomplanIsOpen} />}
        </ToolView>,
      );
    });

    chapterElements.push(
      <ToolbarChapter key="newRoomChapter" title={itx("toolbar.newRoom", "Neuer Raum")} children={newRoomElements} />,
    );
    if (roomsElements.length > 0) {
      chapterElements.push(
        <ToolbarRoomChapter
          key="roomChapter"
          title={itx("toolbar.notPlacedRoom", "Nicht platzierte Räume")}
          children={roomsElements}
        />,
      );
    }
    chapterElements.push(<div style={{ position: "relative", flexGrow: "20" }} key={"placeholder_1"}></div>);
  } else {
    let i = 0;
    const consumerElements = new Array<any>();

    consumerItems.map((template) => {
      i++;
      consumerElements.push(
        <ToolView
          key={`toolbar_style_${(template as any).title}_${i}`}
          index={0}
          data={JSON.stringify(template.toJSON())}
          disabled={!roomplanIsOpen}
          imgSrc={template.image}
        >
          <ConsumerTemplateView template={template} disabled={!roomplanIsOpen} />
        </ToolView>,
      );
    });
    consumerElements.push(<div className="padding" key={"consumerItems_padding"}></div>);

    chapterElements.push(
      <ToolbarChapter
        title={state.translate("components.plural.Consumer", "Verbraucher")}
        children={consumerElements}
        key={"consumerElements"} // no itx
      />,
    );

    let chapterStyle: any = { marginTop: "30px" };
    if (Browser.isMobile()) {
      chapterStyle = {};
    }
    const consumerDaliElements = new Array<any>();
    consumerDaliItems.map((template) => {
      // add daliFloag to data, to differ between normal consumer and dali consumer
      (template as any).daliFlag = true;
      i++;
      consumerDaliElements.push(
        <ToolView
          key={`toolbar_style_${(template as any).title}_${i}`}
          index={0}
          data={JSON.stringify(template.toJSON())}
          disabled={!roomplanIsOpen}
          imgSrc={template.image}
        >
          <ConsumerTemplateView template={template} disabled={!roomplanIsOpen} />
        </ToolView>,
      );
    });
    consumerDaliElements.push(<div className="padding" key={"consumerItems_padding"}></div>);

    chapterElements.push(
      <ToolbarChapter
        title={state.translate("components.plural.Dali", "Dali")}
        children={consumerDaliElements}
        key={"consumerDaliElements"} // no itx
      />,
    );

    if (Browser.isMobile()) {
      chapterStyle = {};
    }
    const buttonElements: any = [];
    buttonItems.map((template) => {
      i++;
      buttonElements.push(
        <ToolView
          key={`toolbar_style_${(template as any).title}_${i}`}
          index={0}
          data={JSON.stringify(template.toJSON())}
          disabled={!roomplanIsOpen}
          imgSrc={template.image}
        >
          <ConsumerTemplateView template={template} disabled={!roomplanIsOpen} />
        </ToolView>,
      );
    });

    const permanetPowerElements: any = [];
    permanentPowerItems.map((template) => {
      i++;
      permanetPowerElements.push(
        <ToolView
          key={`toolbar_style_${(template as any).title}_${i}`}
          index={0}
          data={JSON.stringify(template.toJSON())}
          disabled={!roomplanIsOpen}
          imgSrc={template.image}
        >
          <ConsumerTemplateView template={template} disabled={!roomplanIsOpen} />
        </ToolView>,
      );
    });
    // fills the last row's empty slot so an odd item count stays left-aligned instead of centered
    permanetPowerElements.push(<div className="padding" key={"permanentPowerItems_padding"}></div>);

    chapterElements.push(
      <ToolbarChapter
        title={state.translate("components.Button", "Taster")}
        children={buttonElements}
        key={"buttonElements"} // no itx
      />,
    );

    chapterElements.push(
      <ToolbarChapter
        title={state.translate("toolBar.permanentPower", "Dauerstrom")}
        children={permanetPowerElements}
        key={"fixedpower"} // no itx
      />,
    );

    const inputElements: any = [];
    sensorItems.map((template) => {
      i++;
      inputElements.push(
        <ToolView
          key={`toolbar_style_${(template as any).title}_${i}`}
          index={0}
          data={JSON.stringify(template.toJSON())}
          disabled={!roomplanIsOpen}
          imgSrc={template.image}
        >
          <ConsumerTemplateView template={template} disabled={!roomplanIsOpen} />
        </ToolView>,
      );
    });
    chapterElements.push(
      <ToolbarChapter key="sensor" title={state.translate("toolBar.sensor", "Sensor")} children={inputElements} />,
    );

    const memoElements: any = [];
    memoItems.map((template) => {
      i++;
      memoElements.push(
        <ToolView
          key={`toolbar_style_${(template as any).title}_${i}`}
          index={0}
          data={JSON.stringify(template.toJSON())}
          disabled={!roomplanIsOpen}
          imgSrc={template.image}
        >
          <ConsumerTemplateView template={template} disabled={!roomplanIsOpen} />
        </ToolView>,
      );
    });

    chapterElements.push(
      <ToolbarChapter key="texte" title={state.translate("toolBar.texts", "Texte")} children={memoElements} />,
    );
  }

  return (
    <div id="toolbar" className="toolbar" key={"toolbar"}>
      <ScrollButton
        id="toolbarInner"
        direction="left" // no itx
      />
      <div id="toolbarInner" className="toolbarInner" key={"toolbarInner"}>
        <div className="hint" key={"hint"}>
          {" "}
          {state.translate("toolBar.dragndrophint", "Drag & Drop")}
        </div>
        {chapterElements}
      </div>
      <ScrollButton id="toolbarInner" direction="right" />
    </div>
  );
}

export const consumerItems = new Array<DrawingItemTemplate>();
export const consumerDaliItems = new Array<DrawingItemTemplate>();
export const buttonItems = new Array<DrawingItemTemplate>();
export const permanentPowerItems = new Array<DrawingItemTemplate>();
export const sensorItems = new Array<DrawingItemTemplate>();
export const memoItems = new Array<DrawingItemTemplate>();
export const distributionItems = new Array<DrawingItemTemplate>();

export function createnewDrawingItemTemplate(
  titleShort: string,
  tag: string,
  image: string,
  channeltype: ChannelType,
): DrawingItemTemplate {
  const template = new DrawingItemTemplate();
  if (channeltype) {
    template.type = channeltype;
  }
  template.titleShort = titleShort;
  template.tag = tag;
  template.image = image;

  return template;
}

export function initTemplates() {
  // initTemplates() pusht auf die Modul-Singletons consumerItems/buttonItems/permanentPowerItems/
  // sensorItems (siehe oben) - wird an mehreren Stellen unguarded aufgerufen (openOnboardingProject.tsx,
  // finishProject.tsx, applyExampleProject.ts). Ohne diese Guard würde jeder erneute Aufruf die
  // Werkzeugleiste duplizieren (das Symptom "Symbols was shown double" aus dem useEffect-Kommentar
  // in Toolbar.tsx trat historisch schon einmal auf und wurde dort lokal, aber nicht hier an der
  // Quelle gefixt).
  if (consumerItems.length > 0) {
    return;
  }

  function createnewDeviceTemplate(
    titleShort: string,
    tag: string,
    image: string,
    drawingItemCategory: DeviceClass,
  ): DrawingItemTemplate {
    const template = new DrawingItemTemplate();
    template.className = "DeviceTemplate"; // no itx

    template.titleShort = titleShort;
    template.tag = tag;
    template.image = image;
    template.classification = drawingItemCategory;

    return template;
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Consumers
  ///////////////////////////////////////////////////////////////////////////////

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.switchShort", "Schalt"),
      state.settings.consumerPrefix.switch,
      getChannelTypePicture(ChannelType.Switch),
      ChannelType.Switch,
    ),
  );

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.staircaseLightShort", "Treppenlicht"),
      state.settings.consumerPrefix.staircaseLight,
      getChannelTypePicture(ChannelType.StaircaseLight),
      ChannelType.StaircaseLight,
    ),
  );

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.dimmShort", "Dimm"),
      state.settings.consumerPrefix.dimming,
      getChannelTypePicture(ChannelType.Dimmer),
      ChannelType.Dimmer,
    ),
  );

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.twShort", "TW"),
      state.settings.consumerPrefix.tw,
      getChannelTypePicture(ChannelType.TuneableWhite),
      ChannelType.TuneableWhite,
    ),
  );

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.rgbShort", "RGB"),
      state.settings.consumerPrefix.rgb,
      getChannelTypePicture(ChannelType.Rgb),
      ChannelType.Rgb,
    ),
  );

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.blindShort", "Blind"),
      state.settings.consumerPrefix.blind,
      getChannelTypePicture(ChannelType.Blind),
      ChannelType.Blind,
    ),
  );

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.jalousieShort", "Jalousie"),
      state.settings.consumerPrefix.jalousie,
      getChannelTypePicture(ChannelType.Jalousie),
      ChannelType.Jalousie,
    ),
  );

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.heatingShort", "Heizen"),
      state.settings.consumerPrefix.heating,
      getChannelTypePicture(ChannelType.Heating),
      ChannelType.Heating,
    ),
  );

  consumerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.switchOutletShort", "SteckDose"),
      state.settings.consumerPrefix.switchOutlet,
      state.hostBaseUrl + "images/consumer/PlugSwitchable.png",
      ChannelType.plug_Switch,
    ),
  );
  // dali consumer

  consumerDaliItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.dimmShort", "Dimm"),
      state.settings.consumerPrefix.dimming,
      getChannelTypePicture(ChannelType.Dimmer).replace(".png", "_Dali.png"),
      ChannelType.Dimmer,
    ),
  );

  consumerDaliItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.twShort", "TW"),
      state.settings.consumerPrefix.tw,
      getChannelTypePicture(ChannelType.TuneableWhite).replace(".png", "_Dali.png"),
      ChannelType.TuneableWhite,
    ),
  );

  consumerDaliItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.rgbShort", "RGB"),
      state.settings.consumerPrefix.rgb,
      getChannelTypePicture(ChannelType.Rgb).replace(".png", "_Dali.png"),
      ChannelType.Rgb,
    ),
  );

  //templates.push(createnewDrawingItemTemplate(state.translate("toolBar.rgbwShort","RGBW"),state.translate("toolBar.rgbwShortTag")||"RW",getChannelTypePicture(ChannelType.Rgbw)),ChannelType.Rgbw);
  /////////////////////////////////
  //Buton
  ////////////////////////////
  const templateButton = new DrawingItemTemplate();

  templateButton.titleShort = state.translate("toolBar.ButtonShort", "Taster");
  templateButton.image = state.hostBaseUrl + "images/buttons/touch-6.png";
  templateButton.category = DrawingItemCategory.Button;
  templateButton.classification = DeviceClasses.Button;
  templateButton.tag = state.settings.devicePrefix.button;

  buttonItems.push(templateButton);
  const templateDecentralActor = new DrawingItemTemplate();

  templateDecentralActor.titleShort = state.translate("toolBar.decentralActor", "Dezentraler Aktor");
  templateDecentralActor.image = state.hostBaseUrl + "images/buttons/touch-actor.png"; // no itx
  templateDecentralActor.category = DrawingItemCategory.Button;
  templateDecentralActor.classification = DeviceClasses.DecentralActor;
  templateDecentralActor.tag = state.settings.devicePrefix.decentralActor;

  buttonItems.push(templateDecentralActor);

  /////////////////////////////////////
  // template
  /////////////////////////////////////
  const template = new DrawingItemTemplate();

  template.titleShort = state.translate("toolBar.memo", "Memo");

  template.image = state.hostBaseUrl + "images/memo/memo.png";
  template.category = DrawingItemCategory.Memo;
  (template as any).type = "Memo"; // no itx

  memoItems.push(template);

  //////////////////////////////////////////
  // "permanet powered" tools
  /////////////////////////////////////

  permanentPowerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.outletShort", "Steckd."),
      state.settings.consumerPrefix.outlet,
      // state.translate("toolBar.outletShortTag", "SD"),
      state.hostBaseUrl + "images/consumer/Plug.png",
      ChannelType.plug_230V,
    ),
  );
  permanentPowerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.e230Short", "E-230"),
      state.settings.consumerPrefix.e230,
      // state.translate("toolBar.e230ShortTag", "23E"),
      state.hostBaseUrl + "images/consumer/200V.png", // no itx
      ChannelType.suply230V,
    ),
  );
  permanentPowerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.e400Short", "E-400"),
      state.settings.consumerPrefix.e400,
      //state.translate("toolBar.e400ShortTag", "40E"),
      state.hostBaseUrl + "images/consumer/400V.png", // no itx
      ChannelType.suply400V,
    ),
  );
  permanentPowerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.lan", "LAN"),
      state.settings.consumerPrefix.lan,
      //state.translate("toolBar.lanShortTag", "LAN"),
      state.hostBaseUrl + "images/consumer/lan.png", // no itx
      ChannelType.plug_LAN,
    ),
  );
  permanentPowerItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.lan2", "LAN 2"),
      state.settings.consumerPrefix.lan2,
      //state.translate("toolBar.lan2ShortTag", "LAN2"),
      state.hostBaseUrl + "images/consumer/lan2.png", // no itx
      ChannelType.plug_LAN2,
    ),
  );

  for (const [type, label] of [[ChannelType.plug_USB, "USB"], [ChannelType.plug_TV, "TV"]] as const) {
    permanentPowerItems.push(createnewDrawingItemTemplate(label, state.settings.consumerPrefix.outlet, getChannelTypePicture(type), type));
  }

  distributionItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.intermediateDistribution", "Raum-Unterverteilung"),
      state.settings.consumerPrefix.intermediateDistribution,
      getChannelTypePicture(ChannelType.IntermediateDistribution),
      ChannelType.IntermediateDistribution,
    ),
  );

  //////////////////////////////////////
  // input tools
  ///////////////////////////////////

  sensorItems.push(
    createnewDrawingItemTemplate(
      state.translate("toolBar.inputLock", "Input Lock"),
      state.settings.consumerPrefix.input,
      state.hostBaseUrl + "images/consumer/InputSwitch.png",
      ChannelType.Lock,
    ),
  );

  const sensorButton = new DrawingItemTemplate();

  sensorButton.titleShort = state.translate("toolBar.SensorShort", "Sensor");
  sensorButton.image = state.hostBaseUrl + "images/consumer/Praesenzmelder.png";
  sensorButton.category = DrawingItemCategory.Button;
  sensorButton.classification = DeviceClasses.SensorNew;
  sensorButton.tag = state.settings.devicePrefix.sensor;

  sensorItems.push(sensorButton);

  // Fenster-/Türkontakt - eigenständig von "Sensor" (Bewegungsmelder), damit beide separat
  // ausgewählt/gezählt werden können (siehe equipmentAssumptions.ts). Nutzt vorerst dasselbe
  // Icon wie "Input Lock", da noch kein eigenes Kontakt-Icon im Bestand ist.
}
